module.exports = __WEBPACK_EXTERNAL_MODULE_55__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/tabs/dist/mdc.tabs","commonjs2":"@material/tabs/dist/mdc.tabs","commonjs":"@material/tabs/dist/mdc.tabs","amd":"@material/tabs/dist/mdc.tabs","umd":"@material/tabs/dist/mdc.tabs"}
// module id = 55
// module chunks = 0